import React, { useState, useEffect } from 'react';

interface ResponsiveLogoProps {
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const ResponsiveLogo: React.FC<ResponsiveLogoProps> = ({ alt, className, style }) => {
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const logoSrc = isLandscape 
    ? '/logo_white-horiz.png' 
    : '/logo_white-vertical.png';

  // Apply different styles based on orientation
  const responsiveStyle = isLandscape 
    ? { ...style, width: '160px', height: 'auto' }
    : { ...style, width: '64px', height: 'auto' };

  return (
    <img 
      src={logoSrc} 
      alt={alt} 
      className={className}
      style={responsiveStyle}
    />
  );
};

export default ResponsiveLogo;
